import { render, staticRenderFns } from "./StudentsByGraduationYearAndSchool.vue?vue&type=template&id=989638f0&scoped=true&"
import script from "./StudentsByGraduationYearAndSchool.vue?vue&type=script&lang=js&"
export * from "./StudentsByGraduationYearAndSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989638f0",
  null
  
)

export default component.exports